<template>
  <div>
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>疗养预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>疗养预报名</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams">
        <el-row :gutter="24">
          <el-col :span="7">
            <el-form-item label="疗养时间：" prop="recuperateTime">
              <el-date-picker size="small" v-model="listParams.recuperateTime" style="float: left; width: 150px" type="month" value-format="timestamp" clearable> </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="7">
            <el-form-item label="疗养地点：" prop="address">
              <el-select size="small" v-model="listParams.address" style="float: left; width: 150px" clearable>
                <el-option v-for="item in convalescenceAddressList" :key="item.id" :value="item.name" :label="item.name"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="7">
            <el-form-item label="手机号：" prop="tel">
              <el-input v-model="listParams.tel" size="small" placeholder="请输入预定手机号" style="float: left; width: 150px" clearable> </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-button size="small" @click="searchData" style="margin-top: 4px"> 查询 </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" size="small" v-on:click="outExcel"> 导出 </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table :data="tableData" max-height="800" border>
        <el-table-column prop="" align="center" label="疗养时间">
          <template slot-scope="scope">
            <span>{{ scope.row.recuperateTime | formatDateMonth }}{{ scope.row.up | formatUp }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="address" align="center" label="疗养地点"> </el-table-column>

        <el-table-column prop="level" align="center" label="级别"> </el-table-column>

        <el-table-column prop="tel" align="center" label="预留电话"> </el-table-column>

        <el-table-column prop="securityOffice" align="center" label="保障部门"> </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
import { download } from "../../../../utils/javascript/download";

export default {
  data() {
    return {
      listParams: {
        recuperateTime: "",
        address: "",
        tel: "",
      },
      convalescenceAddressList: [], // 疗养地点列表
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },
  mounted() {
    this.loadConvalescenceAddressList();
    this.loadTableData();
  },
  filters: {
    /**
     * 格式化为月份 2019年1月
     */
    formatDateMonth(val) {
      if (val) {
        var date = new Date(val);
        return date.getFullYear() + "年" + (date.getMonth() + 1) + "月";
      }
      return val;
    },
    /**
     * 格式化每月的上下旬
     */
    formatUp(val) {
      switch (val) {
        case 1:
          return "上";
        case 2:
          return "下";
      }
    },
  },
  methods: {
    outExcel() {
      const bodyParams = Object.assign(
        {},
        {
          recuperateTime: this.listParams.recuperateTime ? this.listParams.recuperateTime : "",
          address: this.listParams.address,
          tel: this.listParams.tel,
        }
      );

      download("/recuperate/applyExcel/export", bodyParams, "疗养预报名");
      // this.$router.open({
      //   path: '/api/web/recuperate/applyExcel/export',
      //   query: bodyParams,
      //   type: 'excel'
      // });
    },
    loadConvalescenceAddressList() {
      this.formLoading = true;
      const bodyParams = Object.assign(
        {},
        {
          page: 1,
          size: 100,
        }
      );
      this.$http({
        url: global.apiUrl + "/recuperate/address/list",
        methods: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.formLoading = false;
            this.convalescenceAddressList = res.body.data.data;
          } else {
            this.formLoading = false;
          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    searchData() {
      this.pager.pageIndex = 1;
      this.loadTableData();
    },
    loadTableData() {
      this.formLoading = true;
      const bodyParams = Object.assign(
        {},
        {
          recuperateTime: this.listParams.recuperateTime,
          address: this.listParams.address,
          tel: this.listParams.tel,
          page: this.pager.pageIndex,
          size: this.pager.pageSize,
        }
      );
      this.$http({
        url: global.apiUrl + "/recuperate/apply/list",
        methods: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.formLoading = false;
            this.tableData = res.body.data.data;
            this.pager.total = res.body.data.total;
          } else {
            this.tableData = [];
            this.pager.total = 0;
            this.formLoading = false;
          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    /**
     * 重置表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>
<style></style>
